import React, { useState } from 'react';
import Avatar from 'react-nice-avatar'
import { useEffect } from 'react';

import { supabase, host } from '../supabaseClient';
import { Avatar as MaterialAvatar } from '@mui/material';

export default function UserAvatar({ userId }) {
    const [config, setConfig] = useState(null)
    const [url, setUrl] = useState(null)

    async function getConfig() {

        const { data, error } = await supabase
            .from('users')
            .select('avatar')
            .eq('id', userId)

        if (data) {
            if (data[0]?.avatar == 'url') {
                setUrl(host + '/storage/v1/object/public/avatars/' + userId + '.png')
            }else if(!data[0]?.avatar){
                
            }else{
                setConfig(JSON.parse(data[0].avatar))
            }
        }

    }

    useEffect(() => {
        getConfig()
    }, [])


    if (url) return (
        <MaterialAvatar src={url}></MaterialAvatar>
    )

    return (
        <Avatar style={{ width: '48px', height: '48px' }} {...config} />
    );
}